import { render, staticRenderFns } from "./RedeemRewardFinish.vue?vue&type=template&id=5e57016d&scoped=true&lang=pug&"
import script from "./RedeemRewardFinish.vue?vue&type=script&lang=js&"
export * from "./RedeemRewardFinish.vue?vue&type=script&lang=js&"
import style0 from "./RedeemRewardFinish.vue?vue&type=style&index=0&id=5e57016d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e57016d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCard,VIcon,VSkeletonLoader})
